import { render, staticRenderFns } from "./YearTrend.vue?vue&type=template&id=63b4e02c&scoped=true&"
import script from "./YearTrend.vue?vue&type=script&lang=js&"
export * from "./YearTrend.vue?vue&type=script&lang=js&"
import style0 from "./YearTrend.vue?vue&type=style&index=0&id=63b4e02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b4e02c",
  null
  
)

export default component.exports